import React, { Component } from "react";
import config from "config/api";
import DynamicForm from "components/UI/DynamicForm";

class PodcastThemeForm extends Component {
  _getI18n() {
    this.i18n = {
      send: "Enregistrer",
      sending: "Enregistrement...",
    };
  }
  render() {
    const { onFormComplete } = this.props;
    const moduleConfig = {
      module: "podcastTheme",
      fetchUrl: config.podcastTheme + "/edit",
      postUrl: config.podcastTheme + "/edit",
      formTitle: this.props.id !== undefined ? "Edition" : "Nouveau Thème de Podcast",
      redirectAfterEdit: false,
      afterEdit: "onFormComplete",
      afterEditLog: "",
      afterEditHideForm: true,
      onFormComplete,
    };

    return <DynamicForm moduleConfig={moduleConfig} {...this.props} />;
  }
}

export default PodcastThemeForm;



// WEBPACK FOOTER //
// ./src/components/UI/PodcastTheme/PodcastThemeForm.jsx